import TestTaskModel from "@/models/lab/TestTaskModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestTaskCollection extends LabServiceCollection {
  model() {
    return TestTaskModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddAsc('order');

    return CollectionFilter;
  }

}
